import { useConnectOauthToken, UseConnectOauthTokenParams } from '@mm/hooks';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { useSelector } from 'react-redux';

export const useGuardedConnectOAuthToken = <
  T extends (...params: any[]) => Promise<string | undefined>,
>(
  featureFlag: string,
  landmineName: string,

  ...params: UseConnectOauthTokenParams<T>
): {
  connect: (...params: Parameters<T>) => Promise<void>;
  popupOpen: boolean;
} => {
  const { openNewBillingModal2023 } = useModalActions();

  const hasFeatureFlag = useSelector(combinedFeatureFlagsSelector)[featureFlag];
  const showUpgradeModal = (onSuccessBilling?: () => void) => {
    openNewBillingModal2023({
      landmineName,
      onSuccessBilling,
    });
  };

  const { connect, popupOpen } = useConnectOauthToken<T>(...params);

  const guardedConnect = async (...args: Parameters<T>) => {
    const actualConnect = () => connect(...args);
    if (featureFlag && !hasFeatureFlag) {
      return showUpgradeModal(actualConnect);
    }
    actualConnect();
  };

  return { connect: guardedConnect, popupOpen };
};
